import React from 'react'
import { IonCol, IonRow, IonChip, IonLabel } from '@ionic/react'
import SvgRenderer from '../../../../../components/svgRenderer/svgRenderer.component'
import { IBodyParts } from '../store/bodySurvey.types'
import ChipComponent from '../components/Chips.component'
import { IOptions } from '../../../../../common/common.types'

interface BodySectionProps {
  title: string
  svgData: IBodyParts[]
  selectedPart: IOptions
  onBodyPartSelection: (bodyVal: IBodyParts) => void
  onZoomSelect?: (bodyPart: IBodyParts | null) => void
  tempBodyParts: IBodyParts[]
  selectedBodyPart: IBodyParts | null
  leftRightLabels: { firstChip: string; secondChip: string }
  viewBox: string
  width?: string
  height?: string
  setZoomButtonVisible: (zoomVisible: boolean) => void
  zoomButtonVisible: boolean
  showZoom?: boolean
}

export const getFillColor = (
  svg: IBodyParts,
  saveBodyParts: IOptions,
  tempBodyParts: IBodyParts[],
  selectedBodyPart: IBodyParts | null
): string => {
  const savedBodyPartIds = saveBodyParts.map((part) => part.id)
  const selectedBodyPartIds = tempBodyParts.map((part) => part.id)
  const examinedBodyParts = tempBodyParts.filter((part) => part.isExamined).map((val) => val.id)

  const isExamined = examinedBodyParts.includes(svg.id)
  const isSaved = savedBodyPartIds.includes(svg.id)
  const isSelected = selectedBodyPartIds.includes(svg.id)
  const hasZoom = svg.hasZoom
  const childrenIds = svg.childrenIds || []

  if (isExamined && isSaved) return 'var(--ion-color-zoll-lime-green)'
  if (isExamined && !isSaved) return 'var(--ion-color-zoll-light-smoke)'
  if (svg.isDisabled) return 'var(--ion-color-zoll-light-smoke)'

  if (hasZoom) {
    if (childrenIds.some((id) => savedBodyPartIds.includes(id))) {
      return 'var(--ion-color-zoll-lime-green)'
    }
    if (svg.id === selectedBodyPart?.id || isSelected) {
      return 'var(--ion-color-zoll-blue-light)'
    }
  } else {
    if (isSaved && !isSelected) return 'var(--ion-color-zoll-lime-green)'
    if (isSelected) return 'var(--ion-color-zoll-blue-light)'
  }

  return 'var(--ion-color-zoll-light-smoke)'
}

const FullBodyView: React.FC<BodySectionProps> = ({
  title,
  svgData,
  selectedPart,
  onBodyPartSelection,
  onZoomSelect,
  selectedBodyPart,
  tempBodyParts,
  leftRightLabels,
  viewBox,
  setZoomButtonVisible,
  zoomButtonVisible,
  showZoom,
}) => (
  <div id={`${title.toLowerCase()}-body`} className='body-container'>
    <IonChip outline className='body-survey-chip body-survey-chip-size mb-5'>
      <IonLabel className='body-survey-chip-label'>{title}</IonLabel>
    </IonChip>
    <IonRow className='image-container mobile-nowrap'>
      <IonCol className='mt-20 first-chip'>
        <ChipComponent label={leftRightLabels.firstChip} />
      </IonCol>
      <IonCol>
        <SvgRenderer
          className='full-body-svg-container'
          svgData={svgData}
          handleSelect={onBodyPartSelection}
          onZoomSelect={onZoomSelect}
          viewBox={viewBox}
          setZoomButtonVisible={setZoomButtonVisible}
          zoomButtonVisible={zoomButtonVisible}
          selectedPart={selectedBodyPart}
          showZoom={showZoom}
          fill={(svgPart) => getFillColor(svgPart, selectedPart, tempBodyParts, selectedBodyPart)}
        />
      </IonCol>
      <IonCol className='mt-20 second-chip'>
        <ChipComponent label={leftRightLabels.secondChip} />
      </IonCol>
    </IonRow>
  </div>
)

export default FullBodyView
